<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-2 pl-2">
    <!-- <h2 class="modal-title-prefix">    <span translate={{modelData.MainTitle}}></span></h2> -->

  <div class="form-group row">
    <div class="col-md-12">
      <yt-fw-date-picker-popup
          formControlName="Datum"
          name="txtDatum" 
          [Label]="'DOKUMENT.DATUM.SINGULAR'"
          [ngClass]="{'is-invalid': submitted && fc.Datum.invalid}"
          (OnDateSelected)='onDatumChange($event)'>
      </yt-fw-date-picker-popup>
    </div>  
  </div>

  <div class="row">
    <div class="col-md-12">
      <yt-fw-default-detail-list-modal [Model]="modelData.MainList.DetailList[0]" [ParentPropertyName]="'DokumentID'" [ParentPropertyValue]="Item.ID" [Disabled]="!Item.ID || Item.ID<=0" [Parameters]="TransferParameters"
      ></yt-fw-default-detail-list-modal>
    </div>
  </div>
</form>